// extracted by mini-css-extract-plugin
module.exports = {"container":"PaginationList_container__3RQvZ","list":"PaginationList_list__2nnVc","placeholder":"PaginationList_placeholder__3vGOC"};